const l = {
  "base.and": "og",
  "base.toc": "Vilkår & betingelser",
  "base.privacyPolicy": "Privatlivspolitik",
  "base.createAccount": "Opret konto",
  "base.signin": "Log ind",
  "base.signup": "Tilmeld dig",
  "base.logOut": "Log ud",
  "authentication.description": "Log ind eller opret en konto",
  "invitation.wrongEmailTitle": "Allerede logget ind",
  "invitation.wrongEmailText":
    "Det ser ud til, at du allerede er logget ind med en anden konto. Log venligst ud og prøv igen.",
  "invitation.invalidLinkTitle": "Ugyldig invitation",
  "invitation.invalidLinkText": "Invitationslinket er ugyldigt",
  "invitation.completeSignup": "Fuldfør tilmeldingen til ",
  "invitation.completeSignupDescription":
    "En bekræftelsesmail er sendt til din adresse. Hvis du ikke kan finde den i din indbakke, så tjek din spammappe.",
  "invitation.completeSignupButton": "Fuldfør tilmelding",
  "invitation.mustSignupTitle": "Du er blevet inviteret til ",
  "invitation.signInToAccept":
    "Log ind for at acceptere invitationen. Du finder et midlertidigt kodeord i den invitationsmail, du har modtaget.",
  "invitation.acceptTermsOnSignup": "Når du logger ind, accepterer du automatisk vores",
  "invitation.accept": "Log ind for at acceptere invitationen",
  "invitation.failed":
    "Det lykkedes ikke at acceptere invitationen. Prøv venligst at logge ud og ind igen – eller bed en administrator om at invitere dig på ny.",
  "invitation.accepted": "Invitation accepteret",
  "invitation.emailNotVerified": "Email ikke bekræftet. Bekræft venligst din email og prøv igen.",
  "country.venezuela": "Venezuela",
  "country.japan": "Japan",
  "country.algeria": "Algeriet",
  "country.france": "Frankrig",
  "country.spain": "Spanien",
  "country.china": "Kina",
  "country.usa": "USA",
  "country.england": "England",
  "country.brazil": "Brasilien",
  "country.italy": "Italien",
  "country.denmark": "Danmark",
  "head.title": "Talkio AI | Træn sprog med AI",
  "landing.title1": "Træn ",
  "landing.title2": "sprog ",
  "landing.title3": "med AI ",
  "landing.subtitle1":
    "Den ultimative app til sproglig træning, der bruger AI-teknologi til at forbedre dine mundtlige sprogfærdigheder.",
  "landing.button.freeTrial": "7 dage gratis",
  "landing.creditCardNotice": "Kreditkort påkrævet – aflys når som helst",
  "landing.text.voiceControlTeam": "Fra holdet bag Voice Control til ChatGPT",
  "landing.text.trustedBy": "Betroet af mere end 500.000 brugere",
  "landing.card.title.advancedAI": "Bygget med avanceret AI-teknologi",
  "landing.card.text.advancedAI":
    "Talkio AI er bygget med avanceret AI-teknologi og lader dig interagere med AI'en gennem tale for at træne din mundtlige sprogbrug.",
  "landing.card.title.multipleLanguages": "Understøtter flere sprog",
  "landing.card.text.multipleLanguages":
    "Vi tilbyder et bredt udvalg af sprog, inklusiv engelsk, kinesisk, fransk og flere andre.",
  "landing.card.title.premiumVoice": "Premium stemmeteknologi",
  "landing.card.text.premiumVoice":
    "Talkio AI tilbyder premium-stemmer og understøtter flere dialekter for de mest populære sprog. Med vores avancerede sprogteknologi kan du fordybe dig i autentiske samtaler og opnå færdigheder i de dialekter, der er vigtigst for dig.",
  "landing.sectionTitle.meetTutors": "Mød AI-tutorerne",
  "landing.sectionText.moreThanTutors":
    "Talkio AI har mere end 400 tutorer med unikke, kunstige personligheder, som står klar til at hjælpe dig på din sprog-rejse.",
  "landing.text.andManyMore": "Og mange flere",
  "landing.text.learnWithAITutors": "Lær med AI-tutorer",
  "landing.text.wonderedAboutTutor":
    "Har du nogensinde overvejet, hvordan det ville være at have en personlig sprog-tutor tilgængelig når som helst, hvor som helst? Hos Talkio AI gør vi denne drøm til virkelighed. Vores AI-tutorer er de perfekte partnere til at forbedre dine mundtlige sprogfærdigheder. Drevet af avanceret AI-teknologi efterligner de menneskelig interaktion og samtale, hvilket giver dig en medrivende og effektiv sprogoplevelse.",
  "landing.text.rememberLanguageLearning":
    "Husk, sprogindlæring handler om mere end grammatik og ordforråd; det handler om at udtrykke sig selvsikkert. Med Talkio AI’s intelligente tutorer kan du tale, øve og nå dine sprog-mål!",
  "landing.sectionTitle.featureSpotlight": "Funktion i fokus",
  "landing.sectionText.featureSpotlight":
    "Udforsk vores udvalg af funktioner, designet til at gøre sprogindlæring til en engagerende og medrivende oplevelse.",
  "landing.text.safeEnvironment": "Trygt og støttende miljø",
  "landing.text.supportiveEnvironment":
    "Vores app giver dig et trygt og støttende miljø til at øve at tale med selvtillid. Med Talkio AI kan du føre meningsfulde samtaler med hjælp fra AI-teknologi og opnå flydende sprog samt evnen til at udtrykke dig på det sprog, du lærer.",
  "landing.sectionTitle.insights": "Indblik",
  "landing.sectionText.realStories": "Virkelige historier fra rigtige brugere af Talkio AI",
  "landing.sectionTitle.faq": "Ofte stillede spørgsmål",
  "landing.sectionText.faq": "Svar på hyppige spørgsmål om Talkio AI",
  "landing.sectionTitle.pricing": "Priser",
  "landing.sectionText.unlockPotential":
    "Frigør dit sproglige potentiale med Talkio. Din vej til at mestre et sprog starter nu.",
  "landing.sectionText.offersForPartners": "Vi tilbyder også løsninger til skoler og teams",
  "landing.imageAlt.landing": "Forside",
  "landing.imageAlt.laurelLeft": "Laurbær venstre",
  "landing.imageAlt.laurelRight": "Laurbær højre",
  "landing.imageAlt.speakingWithAI": "Kvinde taler med AI",
  "testimonial.text1":
    "Jeg har selv brugt Talkio AI til at forbedre mit spanske, og jeg må sige, det er en fantastisk mulighed.",
  "testimonial.text2":
    "Talkio AI er et meget imponerende værktøj og bør være i enhver sprogstuderendes værktøjskasse.",
  "testimonial.text3": "Dette værktøj, Talkio AI, er revolutionerende for sprogindlæring.",
  "testimonial.text4": "Talkio AI – det er et fantastisk produkt.",
  "feature.lifeLikeConversations": "Livagtige samtaler med AI-tutorer",
  "feature.pronunciationTool": "Værktøj til udtaleøvelse",
  "feature.detailedFeedback": "Detaljeret feedback på dine taleevner",
  "feature.interactiveWordbook": "Interaktiv ordbog",
  "feature.supportsLanguages": "Understøtter 40+ sprog",
  "landing.text.voiceConversations": "Talesamtaler",
  "landing.text.voiceConversationsDescription": "Før engagerende samtaler med vores AI-tutorer",
  "landing.text.pronunciation": "Udtale",
  "landing.text.pronunciationDescription": "Vurder og øv din udtale med feedback ord for ord",
  "landing.text.feedback": "Feedback",
  "landing.text.feedbackDescription":
    "Få øjeblikkelig feedback på dine sprogfærdigheder og forslag til forbedring",
  "landing.text.multipleLanguages": "Flere sprog og dialekter",
  "landing.text.multipleLanguagesDescription":
    "Vælg mellem 134 sprog og dialekter til at træne din mundtlige sprogbrug",
  "landing.text.progress": "Fremskridt",
  "landing.text.progressDescription":
    "Følg dine fremskridt og modtag ugentlige rapporter på din sprogindlæring",
  "landing.text.wordbook": "Ordbog",
  "landing.text.wordbookDescription": "Gem og genbesøg ord, du har lært under træningen",
  "landing.text.streaks": "Streaks",
  "landing.text.streaksDescription": "Hold styr på din læring med streaks for at opbygge en vane",
  "landing.text.crosstalk": "Crosstalk",
  "landing.text.crosstalkDescription":
    "Kommunikér med tutor både på dit modersmål og det sprog, du lærer",
  "landing.text.translations": "Oversættelser",
  "landing.text.translationsDescription":
    "Øjeblikkelige oversættelser, der hjælper dig i dine samtaler",
  "landing.text.featureSpotlight": "Funktion i fokus",
  "landing.text.featureSpotlightDescription":
    "Udforsk vores række af funktioner designet til at gøre din sprogindlæring medrivende og engagerende",
  "feature.practiceSpeaking.title": "Øv samtale",
  "feature.practiceSpeaking.bullet1": "Livagtige samtaler med en AI-tutor",
  "feature.practiceSpeaking.bullet2": "Tale-først interaktion",
  "feature.practiceSpeaking.bullet3": "Samtalehjælp",
  "feature.practiceSpeaking.bullet4": "Gentag & prøv igen",
  "feature.worldOfLanguages.title": "En verden af sprog",
  "feature.worldOfLanguages.bullet1": "Understøtter 40+ sprog",
  "feature.worldOfLanguages.bullet2": "Øjeblikkelige oversættelser",
  "feature.worldOfLanguages.bullet3": "Flersproget talegenkendelse",
  "feature.worldOfLanguages.bullet4": "Romanisering af skriftsprog",
  "feature.actionableFeedback.title": "Handlingsrettet feedback",
  "feature.actionableFeedback.bullet1": "Sætningsvurdering",
  "feature.actionableFeedback.bullet2": "Strategier til forbedring",
  "feature.actionableFeedback.bullet3": "AI-forslag",
  "feature.actionableFeedback.bullet4": "Præcisionsscore for tale",
  "feature.pronunciationPractice.title": "Udtaleøvelse",
  "feature.pronunciationPractice.bullet1": "Score ord for ord",
  "feature.pronunciationPractice.bullet2": "Vurdering af udtale",
  "feature.pronunciationPractice.bullet3": "Nøjagtighed, fuldstændighed & flydende tale",
  "feature.pronunciationPractice.bullet4": "Gentag & prøv igen",
  "feature.interactiveWordbook.title": "Interaktiv ordbog",
  "feature.interactiveWordbook.bullet1": "Hold styr på de ord, du lærer",
  "feature.interactiveWordbook.bullet2": "Styrket hukommelse via repetition fra tutor",
  "feature.interactiveWordbook.bullet3": "Oversættelse & oplæsning",
  "feature.interactiveWordbook.bullet4": "Eksempelsætninger",
  "feature.button.startTrial": "Start din gratis prøveperiode",
  "faq.question1": "Er der en gratis plan?",
  "faq.answer1":
    "Nej, alle planer er betalte. Men der er en 7-dages gratis prøveperiode, som kan afmeldes når som helst. Uden binding.",
  "faq.question2": "Hvem står bag Talkio AI?",
  "faq.answer2.part1": "Talkio AI er et produkt fra",
  "faq.answer2.part2":
    "registreret i EU. Aidia ApS overholder persondataforordningen (GDPR) for at sikre alle brugere en tryg og sikker oplevelse.",
  "faq.question3": "Er Talkio AI egnet til begyndere?",
  "faq.answer3":
    "Talkio AI egner sig bedst til dem, der har et grundlæggende kendskab til et sprog og ønsker at forbedre deres mundtlige færdigheder. For begyndere har vi udarbejdet en introduktionsguide, der hjælper dig i gang. Guiden dækker det fundamentale for det valgte sprog, så du kan få mest muligt ud af Talkio AI. Den er gratis og et rigtig godt værktøj for nye sprogstuderende. Prøv guiden og begynd at styrke dine sprogfærdigheder effektivt.",
  "faq.button.gettingStartedGuide": "Prøv den GRATIS introduktionsguide",
  "faq.question4": "Er betaling sikker?",
  "faq.answer4": "Ja, vi bruger Stripe til betaling. Vi gemmer ikke dine kortoplysninger.",
  "faq.question5": "Hvor lagres mine data?",
  "faq.answer5":
    "Dine data lagres på servere i EU: Microsoft (tale og data), Auth0 (autentifikation), Stripe (betaling). Derudover bruger vi tjenester fra OpenAI, Anthropic og Groq til at drive AI'en. Disse data behandles i USA.",
  "faq.question6": "Kan jeg få pengene retur?",
  "faq.answer6":
    "Prøveperioden kan afmeldes når som helst. Hvis du glemmer at afmelde, kan du få pengene retur indenfor 14 dage, hvis du ikke har brugt servicen efter prøveperioden sluttede. Skriv til support@talkio.ai",
  "faq.question7": "Hvilke betalingsmetoder accepterer I?",
  "faq.answer7":
    "Til abonnementer accepterer vi alle større kreditkort samt Paypal. Til engangskøb understøtter vi også WeChat, Przelewy24, Giropay, Alipay og flere. Tilgængeligheden afhænger af din placering.",
  "faq.question8": "Har Talkio en mobilapp?",
  "faq.answer8":
    "Talkio er en Progressiv Web App, hvilket betyder at du kan installere den direkte fra browseren uden App Store eller Google Play. På Android vises en installationsknap efter tilmelding. På iOS skal du åbne Talkio i Safari, trykke på delingsikonet og vælge 'Føj til hjemmeskærm' for at installere den som en almindelig app på din telefon.",
  "faq.question9": "Hvilke browsere kan jeg bruge?",
  "faq.answer9":
    "Talkio AI virker i alle moderne browsere, inklusiv Chrome, Firefox, Safari og Edge. Den fungerer også på mobile browsere på iPhone og Android.",
  "faq.question10": "Hvilke AI-modeller bruger I?",
  "faq.answer10":
    "Talkio AI anvender forskellige AI-modeller fra OpenAI, Anthropic og Meta. Hver model er specialiseret til bestemte opgaver, og tilsammen skaber de en stærk AI-tutor.",
  "faq.question11": "Hvordan adskiller Talkio AI sig fra Voice Control til ChatGPT?",
  "faq.answer11":
    "Talkio AI tilbyder en samlet oplevelse med ChatGPT, specialtilpasset til sprogindlæring. Derudover får du flere funktioner såsom vurdering af udtale, premium stemmeteknologi, flersproget støtte, udvalgte træningsmaterialer, integreret feedback og oversættelsesfunktioner.",
  "faq.question12": "Hvordan kan jeg kontakte jer?",
  "faq.answer12": "Du er meget velkommen til at skrive til hello@talkio.ai",
  "layout.serviceBar.text": "Grundlagt i Danmark. Vi respekterer dit privatliv.",
  "layout.serviceBar.community": "Bliv en del af et globalt fællesskab af sprogstuderende",
  "layout.nav.pricing": "Priser",
  "layout.nav.faq": "FAQ",
  "layout.nav.languages": "Sprog",
  "layout.nav.blog": "Blog",
  "layout.nav.schools": "Til skoler",
  "layout.nav.teams": "Til teams",
  "layout.nav.affiliateProgram": "Affiliate program",
  "layout.nav.signIn": "Log ind",
  "layout.nav.goToApp": "Gå til app",
  "layout.nav.menu": "Menu",
  "layout.cta.description":
    "Den ultimative sprogtrænings-app, der bruger AI-teknologi til at hjælpe dig med at forbedre din mundtlige sprogbrug.",
  "layout.cta.button": "Prøv Talkio AI",
  "layout.footer.pages": "Sider",
  "layout.footer.links": "Links",
  "layout.footer.learningHub": "Læringscenter",
  "layout.footer.faq": "FAQ",
  "layout.footer.blog": "Blog",
  "layout.footer.partners": "Partnere",
  "layout.footer.tools": "Værktøjer",
  "layout.footer.about": "Om",
  "layout.footer.affiliateProgram": "Affiliate program",
  "layout.footer.schools": "Talkio til skoler",
  "layout.footer.teams": "Talkio til teams",
  "layout.footer.languageGuide": "Gratis sprog-guide",
  "layout.footer.termsConditions": "Vilkår & betingelser",
  "layout.footer.privacyPolicy": "Privatlivspolitik",
  "layout.footer.logout": "Log ud",
  "layout.footer.login": "Log ind",
  "layout.footer.blogPosts": "Blogindlæg",
  "layout.footer.blogPost1": "Ny funktion i Talkio AI: Interaktiv sprog-guide",
  "layout.footer.blogPost2": "Talkio integrerer tre nye special-GPT'er",
  "layout.footer.blogPost3": "Forbedr dine IELTS-taleevner med Talkio AI: En trin-for-trin guide",
  "layout.footer.blogPost4": "3 effektive måder at øve mundtlig engelsk på",
  "layout.footer.blogPost5": "Sådan består du engelskeksamener",
  "layout.footer.blogPost6": "Bliv ekspert til TOEFL speaking med Talkio AI: Din essentielle guide",
  "layout.footer.contact": "Kontakt",
  "layout.footer.rights": "Alle rettigheder forbeholdes.",
  "layout.footer.illustrationCredits": "Forsideillustrationer af vectorjuice",
  "pricing.description.perMonthBilledOnce": "pr. måned – betales på én gang",
  "pricing.description.perMonthBilledQuarterly": "pr. måned – betales kvartalsvis",
  "pricing.description.perMonthBilledBiannually": "pr. måned – betales hver 6. måned",
  "pricing.description.perMonthBilledYearly": "pr. måned – betales årligt",
  "pricing.description.perMonth": "pr. måned",
  "pricing.button.buyNow": "Køb nu med 7 dages fuld returret",
  "pricing.button.startFreeTrial": "Start din gratis prøveperiode",
  "pricing.features.refund": "7 dages fuld returret – aflys når som helst",
  "pricing.features.freeTrial": "7 dages gratis prøve – annuller når som helst",
  "pricing.features.supportsLanguages": "Understøtter 40+ sprog",
  "pricing.features.voiceConversations": "Livagtige talesamtaler",
  "pricing.features.instantFeedback": "Øjeblikkelig feedback",
  "pricing.features.weeklyProgressReport": "Ugentlig fremskridtsrapport",
  "pricing.features.pronunciationPractice": "Øvelse i udtale",
  "pricing.features.interactiveWordbook": "Interaktiv ordbog",
  "pricing.features.speechRecognition": "Flersproget talegenkendelse",
  "pricing.features.extraFeatures": "Rollespil, emner, quizzer & meget mere!",
  "accessRequest.pageNotExist": "404 Siden eksisterer ikke.",
  "accessRequest.createAccountTitle": "Opret en konto for at komme i gang",
  "accessRequest.createAccountMessage":
    "For at deltage skal du først oprette en konto. Når du har tilmeldt dig, kan du bede om adgang til systemet.",
  "accessRequest.createAccountButton": "Opret din konto",
  "accessRequest.alreadyHaveAccount": "Har du allerede en konto?",
  "accessRequest.signIn": "Log ind",
  "accessRequest.grantedTitle": "Tillykke!",
  "accessRequest.grantedMessage":
    "Du har nu fået adgang til {serviceName}. Klik nedenfor for at begynde at bruge appen.",
  "accessRequest.goToApp": "Gå til appen",
  "accessRequest.accountExists": "Kontoen findes allerede",
  "accessRequest.accountExistsMessage":
    "Du er allerede medlem med denne konto. For at fortsætte, log ud og tilmeld dig med en anden email.",
  "accessRequest.logOut": "Log ud",
  "accessRequest.requestAccessTitle": "Anmod om adgang for at fortsætte",
  "accessRequest.requestAccessMessage": "Din anmodning skal godkendes, inden du kan få adgang.",
  "accessRequest.checkBackLater": "Tjek venligst senere for at se, om du har fået adgang.",
  "accessRequest.submitRequest": "Send anmodning",
  "accessRequest.pending": "Adgangsanmodning behandles",
};

export default l;
